module.exports = __webpack_public_path__ + "78bfbca9306eda65c69b94ad754eedb4.glb";